export const FREE_DRAW_VERTEX_HANDLE_CLASS = 'free-draw-vertex-handle';
export const FREE_DRAW_POLYGON_PATH_CLASS = 'free-draw-polygon-path';

/** Mid-edge “add vertex” handle — extends {@link FREE_DRAW_VERTEX_HANDLE_CLASS} for freedraw control hit-testing. */
export const VERTEX_HANDLE_MARKER_ADD_CLASS = 'vertex-handle-marker-add';

export const LEAFLET_INTERACTIVE_CLASS = 'leaflet-interactive';

export const POLYGON_STYLE = { color: 'var(--color-guardsman-red)', weight: 2, fillOpacity: 0.2 } as const;
/** Keep a small buffer around the viewport while continuous move updates handle longer pans. */
export const FREE_DRAW_PATH_RENDERER_PADDING = 0.25;

export const FREEDRAW_TOOLBAR_SELECTOR = '[data-freedraw-toolbar]';

/** Root class on the Leaflet divIcon for the per-polygon overlay marker (delete vs edit icon). */
export const FREE_DRAW_POLYGON_OVERLAY_MARKER_CLASS = 'free-draw-delete-control';

/**
 * SVG paths use pointer-events: none unless they have .leaflet-interactive.
 * setStyle({ interactive }) does not toggle that class — we toggle it when entering/leaving edit.
 */
export const VERTEX_HANDLE_OPTIONS: L.CircleMarkerOptions = {
  radius: 6,
  color: 'var(--color-guardsman-red)',
  weight: 2,
  fillColor: 'var(--color-white)',
  fillOpacity: 1,
  className: FREE_DRAW_VERTEX_HANDLE_CLASS,
  bubblingMouseEvents: false,
  interactive: false,
};

/** Below this spacing, edit handles visually crowd each other and should be reduced to a subset. */
export const MIN_VERTEX_HANDLE_PIXEL_DISTANCE = 18;
/** Recompute visible handle subsets at moderate zoom steps during smooth zoom without rerendering on every fractional tick. */
export const VERTEX_HANDLE_VISIBILITY_ZOOM_STEP = 1;

export const VERTEX_TOUCH_TARGET_OPTIONS: L.CircleMarkerOptions = {
  radius: 20,
  color: 'var(--color-black)',
  weight: 5,
  fillColor: 'var(--color-black)',
  fillOpacity: 0,
  opacity: 0,
  className: FREE_DRAW_VERTEX_HANDLE_CLASS,
  bubblingMouseEvents: false,
  interactive: false,
};

/** Smaller black insert handle on long edges (desktop visible marker). */
export const VERTEX_HANDLE_ADD_MARKER_OPTIONS: L.CircleMarkerOptions = {
  radius: 3,
  color: 'var(--color-guardsman-red)',
  weight: 1,
  fillColor: 'var(--color-guardsman-red)',
  fillOpacity: 1,
  className: `${FREE_DRAW_VERTEX_HANDLE_CLASS} ${VERTEX_HANDLE_MARKER_ADD_CLASS}`,
  bubblingMouseEvents: false,
  interactive: false,
};

/** Same touch target pattern as {@link VERTEX_TOUCH_TARGET_OPTIONS} for insert handles on mobile. */
export const VERTEX_HANDLE_ADD_MARKER_TOUCH_OPTIONS: L.CircleMarkerOptions = {
  ...VERTEX_TOUCH_TARGET_OPTIONS,
  className: `${FREE_DRAW_VERTEX_HANDLE_CLASS} ${VERTEX_HANDLE_MARKER_ADD_CLASS}`,
};

/** Minimum screen-space edge length before showing an insert-vertex control between corners. */
export const MIN_EDGE_PIXEL_LENGTH_FOR_INSERT_MARKER = 2;

export const TOLERANCE_STEPS = [
  { minZoomExclusive: 18, tolerance: 0.00001 },
  { minZoomExclusive: 14, tolerance: 0.0001 },
  { minZoomExclusive: 10, tolerance: 0.001 },
  { minZoomExclusive: 7, tolerance: 0.01 },
  { minZoomExclusive: 5, tolerance: 0.1 },
] as const;

export const MIN_POLYGON_OPEN_VERTICES = 3;
export const MAX_DRAW_POLYGON_COUNT = 10;
export const MAX_DRAW_POLYGON_VERTEX_COUNT = 100;

/** Per-polygon delete/edit control rendered as a Leaflet divIcon. */
export const POLYGON_OVERLAY_ICON_SIZE: L.PointExpression = [40, 40];

/** Left-center anchor so the control sits to the right of the geographic anchor point. */
export const POLYGON_OVERLAY_ICON_ANCHOR: L.PointExpression = [0, 20];

export const MULTIPOLYGON_COMPARE_DECIMALS = 4;
